import AudienceFields from "./AudienceFields.vue";

export default AudienceFields;
